export const SEND_NOTIFICATION = "send-notification";
export const CLOSE_NOTIFICATION = "close-notification";
